import {
  Flex,
  Heading,
  Text,
  VStack,
  RadioGroup,
  Radio,
  Button,
  Box,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import MoovenLogo from 'design-system/atoms/mooven-logo';
import useOrgsData from '../../data/useOrgsData';
import {
  DataHandlerFeedback,
  hasDataHandlerFeedBack,
} from '../../utils/dataHandler';
import { useOnboardContractorExisting } from '../../data/useOnboardContractorExisting';
import { pathContractorOnboardingExistingUserCreateOrg } from '../../constants/path';
import { pathOrg } from '../../router/utils/path';

export default function OnBoardExistContractorUser() {
  const orgsDataHandler = useOrgsData();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const inviteToken = searchParams.get('invite-token');
  const onboardContractorExistingHandler = useOnboardContractorExisting();
  const [selectedOrg, setSelectedOrg] = useState<{
    insightId?: number;
    name?: string;
    type?: 'create-new';
  } | null>(null);

  const handleOrgSelect = (value: string) => {
    if (value === 'create-new') {
      setSelectedOrg({ type: 'create-new' });
    } else {
      const selected = orgsDataHandler.data?.find((org) => org.name === value);
      if (selected) {
        setSelectedOrg({ insightId: selected.insightId, name: selected.name });
      }
    }
  };

  const handleNext = async () => {
    if (selectedOrg?.type === 'create-new') {
      const newPath = inviteToken
        ? `${pathContractorOnboardingExistingUserCreateOrg()}?invite-token=${encodeURIComponent(inviteToken)}`
        : pathContractorOnboardingExistingUserCreateOrg();
      navigate(newPath);
    }
    if (selectedOrg?.insightId && !selectedOrg.type) {
      await onboardContractorExistingHandler.onboardLinkContractorExistingUser(
        selectedOrg.insightId.toString()
      );
      navigate(`${pathOrg({ orgId: selectedOrg.insightId.toString() })}`);
    }
  };

  if (
    !orgsDataHandler.data ||
    hasDataHandlerFeedBack([orgsDataHandler, onboardContractorExistingHandler])
  ) {
    return (
      <DataHandlerFeedback
        dataHandlersParam={onboardContractorExistingHandler}
      />
    );
  }
  const invitedOrgName = onboardContractorExistingHandler.data?.orgName;
  return (
    <Flex bgColor="white" justify="center" align="center" p={8}>
      <VStack width={{ sm: '768px' }} gap={8} align="flex-start">
        <VStack gap={4} align="flex-start">
          <Box w="150px" h="33px">
            <MoovenLogo />
          </Box>
          <Heading fontSize="5xl">
            <FormattedMessage
              defaultMessage="You have been invited to access {orgName} Project management."
              id="DnyccM"
              values={{
                orgName: invitedOrgName ? `${invitedOrgName}'s` : 'the',
              }}
            />
          </Heading>
          <Text fontSize="2xl">
            <FormattedMessage
              defaultMessage="Which organisation would you like to connect access to?"
              id="rAVjHR"
            />
          </Text>
        </VStack>
        <VStack gap={4} align="flex-start">
          <Text size="sm" lineHeight={5} fontWeight="700">
            <FormattedMessage
              defaultMessage="Select from your available organisations"
              id="nkMsQ1"
            />
          </Text>
          <RadioGroup
            value={
              selectedOrg?.name ||
              (selectedOrg?.type === 'create-new' ? 'create-new' : '')
            }
            onChange={handleOrgSelect}
          >
            <VStack align="flex-start" spacing={2}>
              {orgsDataHandler.data.map((org) => (
                <Radio key={org.insightId} value={org.name}>
                  {org.name}
                </Radio>
              ))}
              <Text size="sm" lineHeight={5} fontWeight="700" mb={2}>
                <FormattedMessage defaultMessage="or..." id="DSp+iK" />
              </Text>
              <Radio value="create-new">Create new organisation</Radio>
            </VStack>
          </RadioGroup>
        </VStack>
        <Button
          variant="solid"
          colorScheme="brand"
          onClick={handleNext}
          isDisabled={!selectedOrg}
        >
          <FormattedMessage defaultMessage="Next" id="9+Ddtu" />
        </Button>
      </VStack>
    </Flex>
  );
}
